@let branding = brandingService.branding$ | async;

@if (branding !== undefined && branding !== null) {
<div class="micromate-learn">
    <div class="micromate-auth-error" >
        <span class="micromate-error-message">{{'general.autherror' | translate:{appName: branding.appName, supportMail: branding.supportMail} }}</span>
        <button class="micromate-login-button" (click)="login()">{{'general.autherrorButton' | translate }}</button>
    </div>
</div>
}
